var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"icon icon__more-options--system icon--style--outline icon--size--large",attrs:{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}},[_c('path',{attrs:{"d":"M14 19a2 2 0 11-2-2 2 2 0 012 2zM12 3a2 2 0 102 2 2 2 0 00-2-2zm0 7a2 2 0 102 2 2 2 0 00-2-2z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }